import { createPinia } from "pinia";
import piniaPersist from 'pinia-plugin-persist';//pinia持久化插件

const pinia = createPinia();
pinia.use(piniaPersist);

export default pinia;